<template>
    <div class="page flex-col" @wheel="handleWheel" ref="pageContainer">
        <LoginButton />
        <div class="main-container">
            <div class="content-wrapper">
                <!-- 左侧时间轴区域 -->
                <div class="timeline-sidebar">
                    <div class="timeline-container">
                        <!-- 时间轴主线 -->
                        <div class="timeline-line"></div>
                        <!-- 动态生成时间轴节点 -->
                        <div class="timeline-item" v-for="(item, index) in sortedHistoryItems" :key="index">
                            <!-- 时间显示在点的左侧 -->
                            <div class="timeline-date">{{ formatDate(item.time) }}</div>
                            <div class="timeline-dot" :class="{ 'active': hoveredCard === item.id }"
                                @mouseover="hoveredCard = item.id" @mouseleave="hoveredCard = null"
                                @click="viewHistory(item)"></div>
                        </div>
                    </div>
                </div>

                <!-- 右侧内容区 -->
                <div class="content-body">
                    <div class="search-bar">
                        <input type="text" class="search-input" placeholder="搜索历史面试记录" v-model="searchQuery"
                            @keyup.enter="handleSearch">
                        <div class="search-icon-container" @click="handleSearch">
                            <div class="search-icon">
                                <img src="./assets/img/search.png" class="search-icon-img" alt="搜索图标" />
                            </div>
                        </div>
                        
                        <!-- 新增批量管理按钮 -->
                        <button class="batch-management-btn" @click="toggleBatchMode">
                            {{ batchMode ? '取消批量管理' : '批量管理' }}
                        </button>
                        
                        <!-- 批量删除按钮，仅在批量模式且有选中项时显示 -->
                        <button 
                            class="batch-delete-btn" 
                            @click="confirmBatchDelete"
                            v-if="batchMode && selectedItems.length > 0"
                        >
                            批量删除选中项
                        </button>
                    </div>



                    <div v-if="historyItems.length === 0" class="no-data">
                        <span style="font-size: 1.2vw;color: #999;">暂无面试记录</span>
                    </div>

                    <div class="history-cards" :style="{ transform: `translateY(${scrollOffset}px)` }" style="transition: transform 0.3s ease;">
                        <div class="history-card" v-for="(item, index) in filteredHistoryItems" :key="index"
                            @click="handleCardClick(item)"
                            @mouseover="hoveredCard = item.id" 
                            @mouseleave="hoveredCard = null">
                            <!-- 批量选择复选框 -->
                            <input 
                                type="checkbox" 
                                class="batch-checkbox" 
                                v-if="batchMode"
                                v-model="selectedItems"
                                :value="item.id"
                                @click.stop
                            >
                            
                            <div class="card-header">
                                <div class="card-title" v-if="!editingCard || editingCard !== item.id">
                                    {{ item.name }}
                                    <div class="edit-icon" v-if="hoveredCard === item.id && !batchMode"
                                        @click.stop="startEditing(item)">
                                        <img src="./assets/img/edit-icon.png" alt="编辑" />
                                    </div>
                                </div>
                                <div class="card-title-edit" v-else>
                                    <input type="text" v-model="editingName" @keyup.enter="saveEditing(item)"
                                        @blur="saveEditing(item)" ref="editInput" @click.stop />
                                </div>
                            </div>

                            <div class="card-date">{{ formatDate(item.time) }}</div>
                            <div class="card-text">{{ item.positionName }}</div>
                            <SlidableRing style="position: absolute; left: 5.5vw; top: 3vh; scale: 1.5;">
                                <div class="score-inner"
                                    style="position: absolute; left: 15px; top: 15px; width: 30px; height: 30px;">
                                    <div class="score-value">{{ item.score }}</div>
                                    <div class="score-label">得分</div>
                                </div>
                            </SlidableRing>

                            <!-- 修改删除图标显示条件：批量模式下始终显示，否则hover时显示 -->
                            <div class="delete-icon" 
                                v-if="(batchMode || hoveredCard === item.id) && !editingCard" 
                                @click.stop="deleteCard(item.id)">
                                <img src="./assets/img/trash-icon.png" alt="删除" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 页面指示器 -->
        <div v-if="totalPages > 1" class="page-indicator">
            <div class="indicator-dots">
                <div 
                    v-for="page in totalPages" 
                    :key="page" 
                    class="indicator-dot"
                    :class="{ 'active': page === pagination.page_no }"
                    @click="changePage(page)"
                ></div>
            </div>
            <div class="page-info">
                {{ pagination.page_no }} / {{ totalPages }}
            </div>
        </div>

        <div class="modal-overlay" v-if="isModalVisible" @click.self="cancelModal">
            <div class="modal-container">
                <div v-if="modalType === 'edit'" class="modal-content">
                    <div class="modal-title">修改名称</div>
                    <input type="text" class="modal-input" v-model="editingName" ref="modalEditInput"
                        placeholder="请输入新名称" />
                    <div class="modal-buttons">
                        <button class="modal-btn confirm-btn" @click="confirmEdit">确定</button>
                        <button class="modal-btn cancel-btn" @click="cancelModal">取消</button>
                    </div>
                </div>

                <div v-if="modalType === 'delete'" class="modal-content">
                    <div class="modal-title">您确定要删除吗？</div>
                    <div class="modal-buttons">
                        <button class="modal-btn confirm-btn" @click="confirmDelete">确定</button>
                        <button class="modal-btn cancel-btn" @click="cancelModal">取消</button>
                    </div>
                </div>
                
                <!-- 批量删除确认模态框 -->
                <div v-if="modalType === 'batchDelete'" class="modal-content">
                    <div class="modal-title">您确定要删除选中的 {{ selectedItems.length }} 项记录吗？</div>
                    <div class="modal-buttons">
                        <button class="modal-btn confirm-btn" @click="doBatchDelete">确定</button>
                        <button class="modal-btn cancel-btn" @click="cancelModal">取消</button>
                    </div>
                </div>
            </div>
        </div>

        <user-profile-editor :visible.sync="showProfileEditor" :user-info="userInfo" @submit="handleProfileSubmit"
            @cancel="handleProfileCancel" @avatar-updated="handleAvatarUpdate" />
    </div>
</template>

<script>
import { getInterviewData } from '@/api/mianshilishi.js'
import { mapState } from 'vuex'
import SideBar from '@/components/SideBar/index.vue';
import SlidableRing from '@/components/SlidableRing/index.vue'
import UserProfileEditor from '@/components/UserProfileEditor/index.vue';
import { getUserInterviewList, deleteUserInterview, updateUserInterview, addUserInterview } from '@/api/mianshilishi.js'
import { test_uesrinfo } from '@/api/user'
import { getToken } from '@/store/local/auth'

export default {
    components: {
        SlidableRing,
        SideBar,
        UserProfileEditor
    },
    data() {
        return {
            historyItems: [],
            searchQuery: '',
            hoveredCard: null,
            editingCard: null,
            editingName: '',
            username: '',
            isModalVisible: false,
            modalType: null,
            editingItemId: null,
            deleteItemId: null,
            pagination: {
                page_no: 1,
                page_size: 12,
                total: 0
            },
            showProfileEditor: false,
            userInfo: {
                avatar: '',
                name: '',
                email: '',
                phone: '',
                wechat: ''
            },
            // 新增批量管理相关属性
            batchMode: false,
            selectedItems: [],
            // 滚轮滑动相关
            scrollOffset: 0,
            isScrolling: false,
            wheelTimeout: null
        };
    },
    computed: {
        ...mapState('user', ['avatar']),
        filteredHistoryItems() {
            if (!this.searchQuery) return this.historyItems;
            return this.historyItems.filter(item =>
                item.name && item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
        sortedHistoryItems() {
            return [...this.historyItems].sort((a, b) => {
                return new Date(b.time) - new Date(a.time);
            });
        },
        totalPages() {
            return Math.ceil(this.pagination.total / this.pagination.page_size) || 1;
        }
    },
    watch: {
        totalPages(newVal) {
            if (this.pagination.page_no > newVal && newVal > 0) {
                this.changePage(newVal);
            }
        },
        '$route'(to, from) {
            if (to.path.includes('interview_mianshilishi') && from.path.includes('Interview_Analysis')) {
                setTimeout(() => {
                    window.location.reload();
                }, 50);
            }
        },
        // 退出批量模式时清空选择
        batchMode(newVal) {
            if (!newVal) {
                this.selectedItems = [];
            }
        }
    },
    created() {
        if (!getToken()) {
            this.$message.warning('您尚未登录或登录已过期，请重新登录')
            this.$router.push('/store/entry')
            return
        }

        this.fetchInterviewList();
        test_uesrinfo().then(response => {
            this.username = response.data.data.nickname || response.data.data.account || '用户'
            this.userInfo = {
                name: response.data.data.nickname || response.data.data.account || '',
                avatar: response.data.data.avatar || '',
                email: response.data.data.email || '',
                phone: response.data.data.phone || '',
                wechat: response.data.data.wechat || ''
            };
        })
    },
    mounted() {
        // 添加滚轮事件监听
        this.$refs.pageContainer.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    beforeDestroy() {
        // 清理事件监听
        if (this.$refs.pageContainer) {
            this.$refs.pageContainer.removeEventListener('wheel', this.handleWheel);
        }
        if (this.wheelTimeout) {
            clearTimeout(this.wheelTimeout);
        }
    },
    methods: {
        // 滚轮事件处理 - 纵向滑动
        handleWheel(event) {
            event.preventDefault();
            
            if (this.isScrolling || this.totalPages <= 1) return;
            
            const delta = event.deltaY;
            const threshold = 30; // 降低滚动阈值，使响应更敏感
            
            if (Math.abs(delta) < threshold) return;
            
            this.isScrolling = true;
            
            if (delta > 0 && this.pagination.page_no < this.totalPages) {
                // 向下滚动，下一页
                this.changePage(this.pagination.page_no + 1);
            } else if (delta < 0 && this.pagination.page_no > 1) {
                // 向上滚动，上一页
                this.changePage(this.pagination.page_no - 1);
            }
            
            // 防抖处理
            if (this.wheelTimeout) {
                clearTimeout(this.wheelTimeout);
            }
            this.wheelTimeout = setTimeout(() => {
                this.isScrolling = false;
            }, 800); // 增加防抖时间，避免快速滚动
        },
        
        async fetchInterviewList() {
            try {
                if (!getToken()) {
                    this.$message.warning('身份验证已过期，请重新登录')
                    return
                }

                const params = {
                    page_no: this.pagination.page_no,
                    page_size: this.pagination.page_size,
                    ...(this.searchQuery && { interviewName: this.searchQuery })
                };

                const response = await getUserInterviewList(params);

                if (response.data && response.data.code === 1) {
                    const lists = response.data.data?.lists || [];
                    this.historyItems = lists.map(item => ({
                        id: item.id,
                        name: item.interview_name || '未命名',
                        time: item.create_time,
                        score: item.overall_score,
                        positionName: item.interview_position || '岗位名称',
                        interviewId: item.interview_id,
                        createTime: item.create_time,
                    }));
                    this.pagination.total = response.data.data?.count || 0;
                } else {
                    console.error('获取面试历史失败:', response.msg);
                }
            } catch (error) {
                console.error('获取面试历史出错:', error);
            }
        },
        calculateScore(item) {
            return Math.floor(Math.random() * 31) + 70;
        },
        handleSearch() {
            this.pagination.page_no = 1;
            this.fetchInterviewList();
        },
        changePage(page) {
            if (page < 1 || page > this.totalPages || page === this.pagination.page_no) {
                return;
            }
            
            // 添加页面切换动画 - 纵向滑动
            const direction = page > this.pagination.page_no ? 1 : -1;
            this.scrollOffset = direction * 100;
            
            setTimeout(() => {
                this.pagination.page_no = page;
                this.fetchInterviewList();
                this.scrollOffset = 0;
            }, 300);
        },
        async confirmEdit() {
            if (this.editingName.trim()) {
                try {
                    const response = await updateUserInterview(
                        this.editingItemId,
                        this.editingName
                    );
                    const index = this.historyItems.findIndex(i => i.id === this.editingItemId);
                    if (index !== -1) {
                        this.historyItems[index].name = this.editingName.trim();
                    }
                    this.$message.success('修改成功');
                } catch (error) {
                    console.error('修改面试名称失败:', error);
                    this.$message.error('修改失败，请重试');
                }
            }
            this.cancelModal();
        },
        async getInterviewData(id) {
            const response = await getInterviewData(id);
            console.log('获取面试数据响应：', response)
        },
        async confirmDelete() {
            try {
                const response = await deleteUserInterview(this.deleteItemId);
                this.historyItems = this.historyItems.filter(item => item.id !== this.deleteItemId);
                // 如果处于批量模式，从选中列表中移除
                if (this.batchMode) {
                    this.selectedItems = this.selectedItems.filter(id => id !== this.deleteItemId);
                }
                if (this.historyItems.length === 0 && this.pagination.page_no > 1) {
                    this.changePage(this.pagination.page_no - 1);
                } else {
                    this.fetchInterviewList();
                }
                this.$message.success('删除成功');
            } catch (error) {
                console.error('删除面试记录失败:', error);
                this.$message.error('删除失败，请重试');
            }
            this.cancelModal();
        },
        // 批量删除相关方法
        toggleBatchMode() {
            this.batchMode = !this.batchMode;
        },
        confirmBatchDelete() {
            this.modalType = 'batchDelete';
            this.isModalVisible = true;
        },
        async doBatchDelete() {
            try {
                // 这里假设API支持批量删除，参数为ID数组
                const response = await deleteUserInterview(this.selectedItems);
                
                // 过滤掉已删除的项
                this.historyItems = this.historyItems.filter(item => 
                    !this.selectedItems.includes(item.id)
                );
                
                // 重置选中状态
                this.selectedItems = [];
                
                // 重新加载数据
                if (this.historyItems.length === 0 && this.pagination.page_no > 1) {
                    this.changePage(this.pagination.page_no - 1);
                } else {
                    this.fetchInterviewList();
                }
                
                this.$message.success(`成功删除 ${this.selectedItems.length} 项记录`);
            } catch (error) {
                console.error('批量删除失败:', error);
                this.$message.error('批量删除失败，请重试');
            }
            this.cancelModal();
        },
        formatDate(dateString) {
            if (!dateString) return '';
            try {
                const originalDate = new Date(dateString);
                if (isNaN(originalDate.getTime())) {
                    console.error("无效的日期字符串:", dateString);
                    return "无效日期";
                }
                const adjustedDate = new Date(originalDate.getTime());
                const year = adjustedDate.getFullYear();
                const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
                const day = String(adjustedDate.getDate()).padStart(2, '0');
                return `${year}/${month}/${day}`;
            } catch (error) {
                console.error("格式化日期时出错:", error, "日期字符串:", dateString);
                return "日期错误";
            }
        },
        goToHome() {
            this.$router.push('/store/dashboard/profile');
        },
        editProfile() {
            this.showProfileEditor = true;
        },
        feedback() {
            this.$refs.sidebarRef.openFeedbackModal();
        },
        logout() {
            this.$store.dispatch('user/logout').then(() => {
                this.$message.success('已成功退出登录');
                this.$router.push('/store/entry');
            }).catch(error => {
                console.error('退出登录失败:', error);
                this.$message.error('退出登录失败，请重试');
            });
        },
        viewHistory(item) {
            if (!this.editingCard && !this.batchMode) { // 批量模式下不跳转
                this.$router.push({ name: 'Interview_Analysis', params: { id: item.interviewId } })
            }
        },
        // 处理卡片点击
        handleCardClick(item) {
            if (this.batchMode) {
                // 批量模式下点击卡片切换选择状态
                const index = this.selectedItems.indexOf(item.id);
                if (index > -1) {
                    this.selectedItems.splice(index, 1);
                } else {
                    this.selectedItems.push(item.id);
                }
            } else {
                // 非批量模式下正常查看
                this.viewHistory(item);
            }
        },
        startEditing(item) {
            this.editingItemId = item.id;
            this.editingName = item.name;
            this.modalType = 'edit';
            this.isModalVisible = true;
            this.$nextTick(() => {
                if (this.$refs.modalEditInput) {
                    this.$refs.modalEditInput.focus();
                }
            });
        },
        saveEditing(item) {
            if (this.editingName.trim()) {
                const index = this.historyItems.findIndex(i => i.id === item.id);
                if (index !== -1) {
                    this.historyItems[index].name = this.editingName.trim();
                }
            }
            this.editingCard = null;
        },
        deleteCard(id) {
            this.deleteItemId = id;
            this.modalType = 'delete';
            this.isModalVisible = true;
        },
        cancelModal() {
            this.isModalVisible = false;
            this.modalType = null;
            this.editingItemId = null;
            this.deleteItemId = null;
        },
        handleProfileSubmit(formData) {
            console.log('提交的个人资料:', formData);
            this.userInfo = { ...this.userInfo, ...formData };
            this.username = formData.name;
            this.$message.success('个人资料更新成功');
            this.showProfileEditor = false;
        },
        handleProfileCancel() {
            this.showProfileEditor = false;
        },
        handleAvatarUpdate(newAvatarUrl) {
            this.userInfo.avatar = newAvatarUrl;
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.path && from.path.includes('Interview_Analysis')) {
            next(vm => {
                window.location.reload();
            });
        } else {
            next();
        }
    }
};
</script>

<style scoped lang="css" src="./assets/index.response.css" />
<style scoped>
.content-wrapper {
    display: flex;
    width: 100%;
}

.content-body {
    flex: 1;
    overflow: hidden;
    position: relative;
    padding: 20px;
    width: auto;
    min-width: 0;
}

/* 去除所有滚动条 */
* {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

*::-webkit-scrollbar {
    display: none;
}

/* 时间轴侧边栏样式 */
.timeline-sidebar {
    flex: 0 0 auto;
    min-width: 180px;
    max-width: 250px;
    padding: 20px;
    border-right: 1px solid rgba(164, 127, 246, 0.3);
    max-height: calc(100% - 80px);
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

/* 时间轴容器样式 */
.timeline-container {
    position: relative;
    padding: 0 20px;
}

/* 时间轴主线 - 调整位置到中间 */
.timeline-line {
    position: absolute;
    left: 100px;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #A47FF6;
}

.timeline-item {
    position: relative;
    margin-bottom: 60px;
    padding: 5px 0;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
}

.timeline-item:hover {
    background-color: rgba(156, 102, 255, 0.05);
    border-radius: 8px;
}

/* 时间显示在点的左侧 */
.timeline-date {
    width: 70px;
    /* 固定宽度，确保时间对齐 */
    text-align: right;
    padding-right: 15px;
    /* 与点保持距离 */
    font-size: 14px;
    color: #9c66ff;
    font-weight: 500;
    white-space: nowrap;
    /* 防止日期换行 */
}

/* 节点圆形标记 - 位于中间 */
.timeline-dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: linear-gradient(45deg, #9c66ff, #c89bff);
    box-shadow: 0 0 8px rgba(156, 102, 255, 0.5);
    z-index: 1;
    position: relative;
}

.timeline-dot.active {
    box-shadow: 0 0 12px rgba(156, 102, 255, 0.8);
    transform: scale(1.1);
}

/* 搜索栏样式调整，增加批量管理按钮 */
.search-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.batch-management-btn {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    color: white;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.3s;
}

.batch-delete-btn {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    background: #ff4d4f;
    color: white;
    cursor: pointer;
    font-size: 0.9vw;
    transition: all 0.3s;
}

/* 批量选择复选框样式 */
.batch-checkbox {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

/* 历史卡片容器样式 */
.history-cards {
    will-change: transform;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    position: relative;
    overflow: hidden;
}





/* 页面指示器样式 */
.page-indicator {
    position: fixed;
    bottom: 20px;
    right: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    z-index: 100;
}

.indicator-dots {
    display: flex;
    gap: 8px;
}

.indicator-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid rgba(126, 180, 235, 0.3);
}

.indicator-dot.active {
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    border-color: #7EB4EB;
    transform: scale(1.2);
    animation: activePulse 2s ease-in-out infinite;
}

@keyframes activePulse {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(126, 180, 235, 0.4);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(126, 180, 235, 0);
    }
}

.indicator-dot:hover:not(.active) {
    background: rgba(126, 180, 235, 0.4);
    border-color: #7EB4EB;
}

.page-info {
    background: rgba(255, 255, 255, 0.9);
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    color: #666;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(126, 180, 235, 0.2);
}

/* 其他样式保持不变 */
.left {
    flex: 0 0 20%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: linear-gradient(180deg, rgba(177, 110, 249, 0.10) 0%, rgba(126, 180, 235, 0.10) 100%);
    border-radius: 26px;
    border: 1px solid #A47FF6;
    box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(27.85px);
    margin-right: -1.5vw;
}

.div42 {
    color: #656587;
    font-family: "Afacad-Regular", sans-serif;
    font-size: 16px;
    font-weight: 400;
    margin-left: 20px;
}

.card-link {
    text-decoration: none;
    color: inherit;
}

.image5 {
    width: 100%;
    height: 60%;
    object-fit: cover;
    border-radius: 25.92px 25.92px 0 0;
}

.frame-1 {
    padding: 20px;
    overflow-y: auto;
    height: calc(100% - 80px);
}

.vector-1 {
    width: 100%;
    height: auto;
}

.div13 {
    color: #656587;
    font-family: "Afacad-Regular", sans-serif;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 10px;
}

.div14 {
    color: #FFFFFF;
    text-align: center;
    font-family: "Afacad-Regular", sans-serif;
    font-size: 13px;
    font-weight: 400;
    text-decoration: none;
    line-height: 32px;
}

._1 {
    position: absolute;
    width: 13vw;
    min-width: 180px;
    max-width: 300px;
    height: auto;
    top: 3vh;
    left: 0;
    z-index: 0;
}

/* 模态框样式 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-container {
    height: 28vh;
    width: 22vw;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 1vw;
    box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);
    padding: 1.5vw;
    backdrop-filter: blur(15px);
    border: 1px solid rgba(126, 180, 235, 0.3);
}

.modal-content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.modal-title {
    font-size: 1.2vw;
    color: #444;
    margin-bottom: 1.5vh;
    text-align: center;
}

.modal-input {
    width: 90%;
    height: 3.5vh;
    border: none;
    border-radius: 0.5vw;
    padding: 0 1vw;
    margin-bottom: 2vh;
    font-size: 1vw;
    background: rgba(255, 255, 255, 0.8);
    border-bottom: 2px solid #7EB4EB;
    outline: none;
    text-align: center;
}

.modal-buttons {
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin-top: 8vh;
}

.modal-btn {
    width: 7vw;
    height: 5vh;
    border: none;
    border-radius: 2vh;
    font-size: 0.9vw;
    cursor: pointer;
    transition: all 0.3s;
}

.confirm-btn {
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    color: white;
}

.cancel-btn {
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #ddd;
    color: #666;
}

.modal-btn:hover {
    transform: translateY(-0.2vh);
    box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}

.user-profile {
    display: flex;
    align-items: center;
    width: 100%;
    padding-left: 2vw;
}

.avatar {
    width: 3.5vw;
    height: 3.5vw;
    min-width: 3.5vw;
    margin-right: 0.1vw;
    border-radius: 50%;
    overflow: hidden;
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.username {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.history-card {
    border: 1px solid #7EB4EB !important;
    border-image: none !important;
    width: 90%;
}

.sidebar {
    border: none !important;
    border-radius: 0 !important;
    margin-left: 0 !important;
    padding-left: 0 !important;
    width: 20% !important;
    backdrop-filter: blur(27.85px) !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
    /* 移动端样式调整 */
}
</style>